// extracted by mini-css-extract-plugin
export default {"selectMobile":"VZRVle","wrap":"OGY09D","mobile":"IbX3_F"};